export default class extends Controller {
  connect() {
    App.Helpers.listenToCustomEvent(document, "notifications-updated", this.updateNotificationsCount.bind(this));
  }

  updateNotificationsCount(event) {
    const count = parseInt(event.detail.count);
    const prependStr = count > 0 ? `(${count}) ` : "";
    this.element.innerText = `${prependStr}${this.baseTitle}`;
  }

  //
  // GETTERS AND SETTERS
  //

  get baseTitle() {
    return this.element.innerText.replace(/\((.+)\)/, "").trim();
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/page-title-controller.js